module.exports = __webpack_public_path__ + "img/facilities-costs.844436c0.svg";